<template>

    <v-menu 
        v-model="localColorMenu" top 
        nudge-bottom="105" nudge-left="16" 
        :close-on-content-click="false"
        @change="updateColorMenu"
    >

        <template v-slot:activator="{ on }">
            
            <div :style="swatchStyle({value: colorValue, menu: colorMenu})" v-on="on"></div>

        </template>

        <v-card>

            <v-card-text class="pa-0">
            
            <v-color-picker
                v-model="localColorValue" 
                flat
                @input="updateColorValue"
            />
            
            </v-card-text>

        </v-card>	

    </v-menu>

</template>

<script>
export default {
    props: {
        colorMenu: {
            type: Boolean,
            default: false
        },
        colorValue: {
            type: String,
            default: '#000000'
        },
        // vModelType: {
        //     type: String,
        //     default: ''
        // }
    },
    name: 'ColorPicker',
    components: {

    },
    data() {
        return {
            localColorValue: this.colorValue,
            localColorMenu: this.colorMenu,
            // localVModelValue: this.
        }
    },
    mounted() {
        console.log("yo ColorPicker.vue");
    },
    methods: {
        swatchStyle() {
            
            return {
                backgroundColor: this.localColorValue,
                cursor: 'pointer',
                height: '30px',
                width: '30px',
                border:  this.localColorValue.indexOf('FFFF') !== -1 ? '1px solid #CCC' : 'none',
                borderRadius: this.localColorMenu ? '50%' : '4px',
                transition: 'border-radius 200ms ease-in-out'
            };
        },
        updateColorValue() {
            this.$emit('updateColorValue', this.localColorValue);
            this.$emit('changeStatusColorValue');
        },
        updateColorMenu() {
            this.$emit('updateColorMenu', this.localColorMenu);
        }
    },
    watch: {
        colorValue(newVal) {
            this.localColorValue = newVal;
        },
        colorMenu(newVal) {
            this.localColorMenu = newVal;
        },
    },
}
</script>

<style scoped>
    .input-wrapper input[type="text"], .input-wrapper input[type="number"]  {
        padding: 10px 18px 10px 18px;
        border-radius: .4285rem;
        border-color: #2b3553;
        border: 1px solid #cad1d7;
        width: 100%;
        outline: none;
        transition: all .3s;
    }
</style>